export const pxToRem = (pixels, base = 16) => {
  return (pixels / base).toString() + 'rem';
};
